import UserTitle from "../../user/core/UserTitle.tsx";
import ItemTitle from "../../item/core/ItemTitle.tsx";
import { useChat } from "../../../fetch/fetch.chat.ts";
import ErrMessage from "../../core/ErrMessage.tsx";
import ItemImage from "../../item/core/ItemImage.tsx";
import { EMPTY_CHAT } from "../../../const/typeDefault/Chat.ts";
import { IconMessageCircleOff, IconUser } from "@tabler/icons-react";
import { useChatController } from "../../../hooks/useChatController";
import ChatValid from "./ChatValid";
import { CHAT_STATUS } from "../../../types/Chat.ts";
import { LOADING_CIRCLE } from "../../core/loading/LoadingCircle.tsx";

const ChatCompact = ({ id }: { id: string }) => {
  const { chat, isLoading, isError } = useChat(id, EMPTY_CHAT);
  const { getCorrespondent, getChatState } = useChatController();
  //This logic evaluates which id is unequal to the client login
  if (isLoading) return LOADING_CIRCLE;
  if (isError) return <ErrMessage message={isError.message} />;

  const correspondent = getCorrespondent(chat);
  const chatState = getChatState(chat);
  //The Chat is no more active.
  if (correspondent?.state !== CHAT_STATUS.ACTIVE)
    return (
      <>
        <div>
          <IconMessageCircleOff />
        </div>
        <div>
          <label className="text-lg truncate">
            <ItemTitle id={chat.productId} />
          </label>
          <div className="flex gap-2 items-center text-xs uppercase font-semibold opacity-60">
            Der Chat wurde beended.
          </div>
        </div>
      </>
    );

  if (!chatState) {
    console.error("Chat error");
    return (
      <>
        <div>
          <IconMessageCircleOff />
        </div>
        <div>
          <label className="text-lg truncate">
            <ItemTitle id={chat.productId} />
          </label>
          <div className="flex gap-2 items-center text-xs uppercase font-semibold opacity-60">
            Ein Fehler ist aufgetreten.
          </div>
        </div>
      </>
    );
  }
  return (
    <>
      <div>
        <ItemImage id={chat.productId} className="size-18 rounded-box" />
        {chatState.unreadMessages > 0 && (
          <span className="absolute top-1 right-1 badge badge-info justify-end">
            {chatState.unreadMessages}
          </span>
        )}
      </div>
      <div className="flex flex-col w-full">
        <label className="text-lg truncate">
          <ItemTitle id={chat.productId} />
        </label>

        <div className="flex gap-2 items-center text-xs uppercase font-semibold opacity-60">
          <ChatValid
            chatId={id}
            fallback={"Der Chat wurde beendet"}
            loading={LOADING_CIRCLE}
          >
            <IconUser />
            <UserTitle userId={correspondent.userId} />
          </ChatValid>
        </div>
      </div>
    </>
  );
};
export default ChatCompact;
